// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"0f48a19f","885":"4053604b"}[chunkId] + ".chunk.js";
};